export default __webpack_public_path__ + "static/media/visibility_ok.d020740e.svg";